import { forwardRef } from "react";
export const InputFile = forwardRef(
  (
    {
      type = "file",
      icon,
      label,
      name, 
      accept = "",
      placeholder,
      pattern,
      onChange = () => {},
      onKeyup,
      onBlur,
      defaultValue,
      disabled = false,
      required = false,
      value = "",
      files = [],
      className,
      classLabel,
      title,
    },
    ref
  ) => {
    return (
      <>
        <div>
          <label className={className}>
            {icon} {label}
            <input
              label={label}
              name={name}
              autoComplete="do-not-autofill"
              title={title}
              ref={ref}
              type={type}
              files={files}
              accept={accept}
              className={className}
              onChange={onChange}
              placeholder={placeholder}
              pattern={pattern}
              defaultValue={defaultValue}
              disabled={disabled}
              required={required}
              onKeyUp={onKeyup}
              onBlur={onBlur}
              value={value}
            ></input>
          </label>
        </div>
      </>
    );
  }
);
export default InputFile;
